import { keyframes } from '@chakra-ui/react'

const shake = keyframes`10%, 90% { transform: translate3d(-1px, 0, 0); }
20%, 80% { transform: translate3d(+2px, 0, 0); }
30%, 70% { transform: translate3d(-4px, 0, 0); }
40%, 60% { transform: translate3d(+4px, 0, 0); }
50% { transform: translate3d(-4px, 0, 0); }`

export const shakeAnimation = `${shake}  800ms ease-in-out;`
